// src/context/SidebarBeatContext.jsx
// ─────────────────────────────────────────────────────────────────────────────
// BoneBeat modülünün sidebar açık/kapalı durumunu yönetir.
// Ana SidebarContext (drawer) ile bağımsızdır.
// ─────────────────────────────────────────────────────────────────────────────
import React, { createContext, useContext, useState, useCallback } from "react";

const SidebarBeatContext = createContext(null);

export function SidebarBeatProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar   = useCallback(() => setIsOpen(true),    []);
  const closeSidebar  = useCallback(() => setIsOpen(false),   []);
  const toggleSidebar = useCallback(() => setIsOpen(s => !s), []);

  return (
    <SidebarBeatContext.Provider value={{ isOpen, openSidebar, closeSidebar, toggleSidebar }}>
      {children}
    </SidebarBeatContext.Provider>
  );
}

export function useSidebarBeat() {
  const ctx = useContext(SidebarBeatContext);
  if (!ctx) throw new Error("useSidebarBeat must be used within SidebarBeatProvider");
  return ctx;
}
